import { size } from '@everlywell/leaves';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { VITAMINS_PROMO_CARD_SLUG } from 'utils/constants/vitaminsAndSupplements';
import { IGatsbyImage } from 'utils/types';

import * as S from './styles';

export type PromoProps = {
  slug: string;
  content: string;
  image: IGatsbyImage;
  active: boolean;
  link: any;
  row: number;
  column: number;
  span: number;
};

const styles = { borderRadius: `${size.xs3}px` };

export const PromoCard: React.FC<PromoProps> = ({
  slug,
  image,
  content,
  link,
  active,
  row,
  column,
  span,
}) => {
  if (!active) return null;

  const handlePromoClick = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: slug || 'PIP Promo Unit',
      },
    });
  };

  // TODO: Get rid of this logic once we end the launch promo, or replace
  // with a better Contentful managed way to create styled content.
  // One-off hack to meet design requirements from CG-1614
  const isVitaminPromo = slug === VITAMINS_PROMO_CARD_SLUG;
  const vitaminPromoContent = (
    <>
      Meet our <em>new</em> line of{' '}
      <span>vitamins and supplements: nourishment for a healthier you</span>
    </>
  );
  const promoContent = isVitaminPromo ? vitaminPromoContent : content;

  return (
    <S.PromoWrapper href={link} row={row} column={column} span={span}>
      <S.ImageWrapper>
        <GatsbyImage
          image={image.gatsbyImageData}
          imgStyle={styles}
          alt={image.description || ''}
          loading="eager"
        />
      </S.ImageWrapper>
      <S.ContentWrapper>
        <S.PromoContent isVitamin={isVitaminPromo}>
          {promoContent}
        </S.PromoContent>
        <S.PromoButton
          appearance="primary"
          hasArrow={true}
          onClick={handlePromoClick}
        >
          Learn More
        </S.PromoButton>
      </S.ContentWrapper>
    </S.PromoWrapper>
  );
};
